/**
 * Defines status colour options.
 */
export enum StatusColour {
  Default = 'default',
  Green = 'green',
  Amber = 'amber',
  Red = 'red',
}
